import React, { useState } from "react";
import logo from "assets/images/header/logo.svg";
import hamburger from "assets/images/header/hamburger.svg";
import times from "assets/images/header/times.svg";
import chevronDown from "assets/images/header/chevron-down.svg";
import { menuData } from "./config";
import { Link } from "gatsby-link";
import search from "assets/images/search.svg";

function Header() {
  const [openMenu, setOpenMenu] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [selectedSubMenu, setSelectedSubMenu] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchText, setSearchText] = useState("");

  return (
    <>
      <div className="bg-black px-5 lg:px-12 py-4 lg:p-0 flex items-center justify-between lg:justify-start lg:gap-28 sticky top-0 z-[999]">
        <Link to="/" className="flex gap-3 items-center">
          <img src={logo} alt="logo" />
          <p className="text-lg lg:text-2xl text-primary xs:font-cairo flex flex-col">
            <span>LegalSections</span>
            <span className="text-sm lg:text-base text-white xs:xs:font-cairo self-end">
              Law That Leads
            </span>
          </p>
        </Link>
        <img
          src={openMenu ? times : hamburger}
          alt="menu"
          className="lg:hidden"
          onClick={() => setOpenMenu((openMenu) => !openMenu)}
        />
        {/* Header - Desktop */}
        <div className="hidden lg:flex gap-8 pt-8">
          {menuData?.map((menu) => {
            return (
              <div
                key={menu.id}
                className="text-base text-white xs:font-cairo hover:text-primary transition-colors duration-300 pb-8 cursor-pointer group"
              >
                {menu.link ? (
                  <Link to={menu.link}>{menu.text}</Link>
                ) : (
                  menu.text
                )}
                {menu.subMenu && (
                  <div className="hidden group-hover:flex justify-around fixed top-[87px] bg-black px-12 py-8 border-t border-t-greyLight left-0 right-0 z-50">
                    {menu.subMenu?.map((item) => {
                      return (
                        <div
                          key={item.id}
                          className="text-white group-tertiary"
                        >
                          {item.link ? (
                            <Link to={item.link}>{item.text}</Link>
                          ) : (
                            <>
                              <p className="pb-1 border-b border-primary inline-block">
                                {item.text}
                              </p>
                              <div className="pb-4"></div>
                              {item.tertiaryMenu?.map((subItem) => (
                                <Link
                                  to={subItem.link}
                                  className="hidden group-tertiary-hover:block hover:text-primary"
                                >
                                  {subItem.text}
                                </Link>
                              ))}
                            </>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* <div className="border border-primary hidden lg:flex items-center">
          <div
            className="search-icon cursor-pointer"
            onClick={() => setIsSearching(true)}
          >
            <img src={search} alt="search" />
          </div>
          {isSearching && <div className="w-[2px] h-4 bg-primary"></div>}
          <input
            className={`custom-search text-base font-cairo ${
              isSearching ? "open" : ""
            }`}
            type="search"
            placeholder="enter your text here"
            onBlur={(e) => setSearchText(e.target.value)}
          />
          {isSearching && (
            <p
              className="text-sm text-white font-cairo pr-2 cursor-pointer"
              onClick={() => console.log(searchText)}
            >
              SEARCH
            </p>
          )}
        </div> */}
      </div>
      {/* Header - Mobile*/}
      <div
        className={`${
          openMenu ? "block" : "hidden"
        } bg-black lg:hidden fixed left-0 right-0 z-[999] h-full overflow-auto`}
      >
        {menuData?.map((item) => {
          const isMenuActive = selectedMenu === item.id;
          return (
            <div key={item.id} className="px-4 border-t border-greyLight">
              <div
                className="py-3"
                onClick={() =>
                  isMenuActive
                    ? setSelectedMenu(false)
                    : setSelectedMenu(item.id)
                }
              >
                <p className="text-base text-primary xs:font-cairo flex items-center justify-between cursor-pointer">
                  {item.link ? (
                    <Link to={item.link}>{item.text}</Link>
                  ) : (
                    item.text
                  )}
                  {item.subMenu && (
                    <img
                      src={chevronDown}
                      alt="open-menu"
                      className={`${
                        isMenuActive ? "rotate-180" : ""
                      } transition-transform duration-300 w-4`}
                    />
                  )}
                </p>
              </div>
              {item.subMenu && isMenuActive ? (
                <>
                  {item.subMenu?.map((subItem, i, arr) => {
                    const isSubMenuActive = selectedSubMenu === subItem.id;
                    return (
                      <div
                        key={subItem.id}
                        className={`pl-3 py-3 border-primary ${
                          i !== arr.length - 1 ? "border-b" : ""
                        }`}
                        onClick={() =>
                          isSubMenuActive
                            ? setSelectedSubMenu(false)
                            : setSelectedSubMenu(subItem.id)
                        }
                      >
                        <p className="text-[15px] text-white xs:font-cairo flex items-center justify-between cursor-pointer">
                          {subItem.link ? (
                            <Link to={subItem.link}>{subItem.text}</Link>
                          ) : (
                            subItem.text
                          )}
                          {subItem.tertiaryMenu && (
                            <img
                              src={chevronDown}
                              alt="open-menu"
                              className={`${
                                isSubMenuActive ? "rotate-180" : ""
                              } transition-transform duration-300 w-4`}
                            />
                          )}
                        </p>
                        {subItem.tertiaryMenu && isSubMenuActive ? (
                          <div className="flex flex-col gap-3 pl-3 py-4">
                            {subItem.tertiaryMenu?.map((data, i) => (
                              <Link
                                to={data.link}
                                key={i}
                                className="text-sm text-white hover:text-primary xs:font-cairo transition-colors duration-300 cursor-pointer"
                              >
                                {data.text}
                              </Link>
                            ))}
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </>
              ) : null}
            </div>
          );
        })}
      </div>
    </>
  );
}
export default Header;
